var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "position-relative" }, [
    _vm.isLoggedIn
      ? _c("div", { staticClass: "dropdown" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown-menu small m-0 p-0 mw-100" }, [
            _c(
              "div",
              {
                staticClass: "list-group",
                attrs: { "aria-labelledby": "accountMenuList" }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "list-group-item small",
                    attrs: { href: _vm.$ceres.urls.myAccount }
                  },
                  [
                    _c("i", { staticClass: "fa fa-user" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$translate("Ceres::Template.loginMyAccount"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [{ name: "logout", rawName: "v-logout" }],
                    staticClass: "list-group-item small",
                    attrs: { href: "#" }
                  },
                  [
                    _c("i", { staticClass: "fa fa-sign-out" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$translate("Ceres::Template.loginLogout"))
                    )
                  ]
                )
              ]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn
      ? _c("div", [
          _vm.showLogin
            ? _c(
                "a",
                {
                  staticClass: "nav-link",
                  attrs: {
                    "data-testing": "login-select",
                    href: _vm.isLogin ? "javascript:void(0)" : "#login",
                    "data-toggle": _vm.isLogin ? false : "modal",
                    "aria-label": _vm.$translate("Ceres::Template.login")
                  },
                  on: {
                    click: function($event) {
                      _vm.createLoginModal()
                      _vm.unmarkInputFields()
                    }
                  }
                },
                [
                  _c("i", {
                    staticClass: "snaply-account mr-1",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              )
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "dropdown-toggle nav-link",
        attrs: {
          href: "#",
          id: "accountMenuList",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
          "data-boundary": "window"
        }
      },
      [
        _c("i", {
          staticClass: "snaply-account mr-1",
          attrs: { "aria-hidden": "true" }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }